var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ADBDetailsData from "./ADBDetailsData";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Errormsg from "../../../../../../shared-library/components/errorMsg";
import Loader from "@frameworks/shared-library/components/Loader";
var ADBDetails = function () {
    var _a = __read(React.useState([]), 2), adbDetails = _a[0], setAbdDetails = _a[1];
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getAdbDetails = function (acCode) {
        setLoader(true);
        var localAdbDetails = [];
        di.clients
            .getADBDetailsData({ acCode: acCode })
            .then(function (resp) {
            console.log("resp1", resp);
            if (resp.length > 0)
                localAdbDetails = resp;
        })
            .catch(function (error) {
            localAdbDetails = [];
        });
        var reqObj = {
            acCode: acCode,
            page: 1,
            pageSize: 500,
        };
        di.clients
            .getBrokingADBDetailsData(reqObj)
            .then(function (resp) {
            console.log("resp2", resp);
            if (resp && resp.length > 0) {
                resp.map(function (localItem) {
                    localAdbDetails.push(localItem);
                });
            }
            setAbdDetails(localAdbDetails);
            setLoader(false);
        })
            .catch(function (error) {
            setAbdDetails(localAdbDetails);
            setLoader(false);
        });
        console.log("localAdbDetails", localAdbDetails);
    };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode))
            getAdbDetails(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode);
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode]);
    return (React.createElement(React.Fragment, null,
        React.createElement("table", { className: "adb-table" },
            React.createElement("thead", null,
                React.createElement("tr", { className: "DMSansMedium_12_500  txt_primaryGrey" },
                    React.createElement("th", null, "Scheme Type"),
                    React.createElement("th", null, "Scheme Name/Account Code"),
                    React.createElement("th", null,
                        "End Date/",
                        React.createElement("br", null),
                        "Start Date"),
                    React.createElement("th", null,
                        "Subscription",
                        React.createElement("br", null),
                        "Fees"),
                    React.createElement("th", null,
                        "Max",
                        React.createElement("br", null),
                        "TO Limit"),
                    React.createElement("th", null,
                        "TO ",
                        React.createElement("br", null),
                        "Consumed"),
                    React.createElement("th", null,
                        "Balance",
                        React.createElement("br", null),
                        "Turnover"),
                    React.createElement("th", null,
                        "Adb",
                        React.createElement("br", null),
                        "Consumed"),
                    React.createElement("th", null,
                        "Adb Balance % ",
                        React.createElement("br", null),
                        "Utilization"),
                    React.createElement("th", null, "Status"),
                    React.createElement("th", null,
                        "ADB",
                        React.createElement("br", null),
                        "Expired"),
                    React.createElement("th", null))),
            loader && (React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: "position-relative client-loader", colSpan: 11 },
                        React.createElement(Loader, null))))),
            !loader && (React.createElement(React.Fragment, null, adbDetails && adbDetails.length > 0 ? (adbDetails.map(function (adb) {
                return React.createElement(ADBDetailsData, { adb: adb });
            })) : (React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 11 },
                        React.createElement(Errormsg, { msg: "No Data Found" }))))))))));
};
export default ADBDetails;
